// extracted by mini-css-extract-plugin
module.exports = {"container":"LogoButton_container__2nTDC","icon-update":"LogoButton_icon-update__2FLHl"};